import { BaseService } from './../base'
export class RequestFilesSalariesService extends BaseService {
    static get entity () {
        return 'file_salary'
    }
    static get name () {
        return 'file_salary'
    }
    static async create(data,config) {
        return this.submit('post', `${process.env.VUE_APP_API_URL}/api/${this.entity}`, this.name,data,config);        
    }
}